import {Inject, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,
  name: 'bringozCapitalize'
})
export class BringozCapitalizePipe implements PipeTransform {

  constructor(@Inject("commonsService") private commonsService) {
  }

  transform(string: string): string {
    return this.commonsService.capitalize(string);
  }
}
